<template lang="html" src="./AdvertisingMessage.html"></template>

<script>
import mixins from "../../../../../Mixins.js";
export default {
  name: "advertisingMessage",
  mixins: [mixins],
  data() {
    return { 
      messages: [],
      message: {
        id: null,
        active: null,
        description: null,
        text: null,
      },
      defaultTableText: "Aguarde, estamos carregando as informações...",
      modalTitle: "",
      messageFilter: "",
      disableModalEdition: false,
      disableSwitch: false,
      invalid: {
        description: false,
        message: false,
      },
    };
  },
  mounted: function() {
    this.init()
  },
  methods: { 
    init() {
      this.getAdvertisingMessage()
    },
    getAdvertisingMessage() {
      this.axios.get(`${this.$store.state.filooServer}message/list/login-advertising`, 
        { headers: { Authorization: this.$session.get("bearerDefault") }, } )
        .then( response => {
          this.defaultTableText = "Nenhum resultado encontrado"
          this.messages = response.data
        })
        .catch( error => {
          this.defaultTableText = "Nenhum resultado encontrado"
          console.log({
            endpointURL: "message/list/login-advertising",
            error_getPlanServices: error,
          })
          this.showNotifyWarning(
            "Ocorreu um erro ao buscar as messagens. Por favor, tente novamente mais tarde!", 
            5000,
          )
        })
    },
    handleSelected(item) {
      this.message = { ...null }
      this.message.id = item.id
      this.message.active = item.active
      this.modalTitle = "Editar mensagem"
      this.disableModalEdition = true
      this.disableSwitch = false
      this.$bvModal.show("modal-messages-update")
      this.axios.get(`${this.$store.state.filooServer}message/${item.id}`, 
        { headers: { Authorization: this.$session.get("bearerDefault") }, } )
        .then( response => {
          this.message = { ...response.data }
          this.disableModalEdition = false
        })
        .catch( error => {
          this.$bvModal.hide("modal-messages-update")
          console.log({
            endpointURL: `message/${item.id}`,
            error_handleSelected: error,
          })
          this.showNotifyWarning(
            "Ocorreu um erro ao tentar selecionar a mensagem. Por favor, tente novamente mais tarde!", 
            5000,
          )
        })
    },
    checkFields() {
      let readyToUpdate = true
      if (!this.message.description) {
        this.invalid.description = true
        readyToUpdate = false
      }
      if (!this.message.text) {
        this.invalid.message = true
        readyToUpdate = false
      }
      if (readyToUpdate) this.updateMessages()
      else return false 
    },
    updateMessages() {  
      const method = this.message.id ? "put" : "post"
      const url = this.message.id ?
        `message/update/${this.message.id}` : "message/create?login-advertising=true"
      this.axios({
        method,
        url: this.$store.state.filooServer + `${url}`,
        data: {
          active: this.message.active,
          description: this.message.description,
          days: 0,
          text: this.message.text,
        }
      })
      .then( () => {
        this.$bvModal.hide("modal-messages-update")
        const messagem = method === "post" ? 
          "Mensagem adicionada com sucesso!" : 
          "Mensagem atualizada com sucesso!"
        this.showNotifySuccess(
          "Sucesso", 
          messagem, 
          5000,
        )
        this.getAdvertisingMessage()
      })
      .catch( error => {
        console.log({
          endpointURL: `${url}`,
          error_updateMessage: error,
        })
        this.$bvModal.hide("modal-messages-update")
        this.showNotifyWarning(
          "Não foi possível registrar a mensagem. Por favor, tente novamente mais tarde!", 
          5000,
        )
      })
    },
    handleNewMessage() {
      this.message = { ...null, active: true }
      this.disableSwitch = true
      this.modalTitle = "Nova mensagem"
      this.$bvModal.show("modal-messages-update")
    },
  }
};
</script>

<style lang="scss" src="./AdvertisingMessage.scss">
</style>
